import * as fetcher from "../fetcher";
import { type Opportunity } from "../opportunity/types";

export const convertAppointmentToProject = (
  appointmentId: string | number | undefined,
  paramName: string
) => {
  if (!appointmentId) {
    return null;
  }
  const id = appointmentId.toString();
  return fetcher.core.post<Opportunity, false>(
    `/appointments/createProject?${paramName}=${id}`,
    {}
  );
};
